module.exports = __webpack_public_path__ + "static/media/PB_G_10.3f8c554a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_bar/green/PB_G_10.png
// module id = 223
// module chunks = 0